module.exports = __webpack_public_path__ + "static/6305-woodrose-50-a94a41fe2d2373f691ffdbd448a92028.jpg";